import React, { Component } from 'react';
import '../styles.css';

export default class CategoryImage extends Component {
  render() {
    return (
      <img
        src={this.props.src}
        style={{width: `100%`, height: `100%` }}
        alt=""
      />
    );
  }
}
